<template>
  <div id="app" class="page logo-page">
    <div class="page-logo-container"><PageLogo ref="pageLogo" :home-url="$router.resolve({ name: 'home' }).href"></PageLogo></div>
    <slot></slot>
  </div>
</template>
<script>
import PageLogo from '@/components/header/PageLogo.vue';

export default {
  components: {
    PageLogo,
  },
};
</script>
<style lang="postcss">
.logo-page {
  min-height: 100vh;

  .page-logo-container {
    margin-top: var(--space-10);
    margin-bottom: var(--space-10);
    display: flex;
    justify-content: center;
  }
}
</style>
